import React from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { pdfjs } from 'react-pdf';
import styles from './index.module.scss';
import BackIcon from './../images/back.svg';
import NextIcon from './../images/next.svg';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFReader = ({ fileReaderInfo, updateFileReaderInfo, onPageChange }) => {
  function onRenderSuccess() {
    const importPDFCanvas = document.querySelector('.import-pdf-page canvas');
    const pdfAsImageSrc = importPDFCanvas.toDataURL();

    updateFileReaderInfo({ currentPage: pdfAsImageSrc });
  }

  function onDocumentLoadSuccess({ numPages }) {
    console.log('onDocumentLoadSuccess', numPages);
    updateFileReaderInfo({ totalPages: numPages });
  }

  function changePage(offset) {
    onPageChange(fileReaderInfo.currentPageNumber + offset);
  }

  const nextPage = () => changePage(1);
  const previousPage = () => changePage(-1);

  return (
    <div className={styles.pdfReader}>
      <div className={styles.fileContainer}>
        {fileReaderInfo.file && fileReaderInfo.file.name !== 'whiteboard' && (
          <Document
            className={styles.document}
            file={fileReaderInfo.file}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={(error) => console.error('Error loading PDF document:', error)}
            loading={<div>Loading PDF...</div>}
            error={<div>Failed to load PDF file.</div>}
            noData={<div>No PDF file specified.</div>}
          >
            {fileReaderInfo.currentPageNumber > 0 && (
              <Page
                className="import-pdf-page"
                onRenderSuccess={onRenderSuccess}
                onRenderError={(error) => console.error('Error rendering PDF page:', error)}
                onLoadError={(error) => console.error('Error loading PDF page:', error)}
                pageNumber={fileReaderInfo.currentPageNumber}
              />
            )}
          </Document>
        )}
      </div>
      {fileReaderInfo.totalPages > 1 && (
        <div className={styles.pageInfo}>
          <button
            type="button"
            disabled={fileReaderInfo.currentPageNumber <= 1}
            onClick={previousPage}
          >
            <img src={BackIcon} alt="Back" />
          </button>
          <span className={styles.pageInfoDetails}>
            Page&nbsp;<b>{fileReaderInfo.currentPageNumber}</b>&nbsp;of{' '}
            {fileReaderInfo.totalPages || '--'}
          </span>
          <button
            type="button"
            disabled={fileReaderInfo.currentPageNumber >= fileReaderInfo.totalPages}
            onClick={nextPage}
          >
            <img src={NextIcon} alt="Next" />
          </button>
        </div>
      )}
    </div>
  );
};

export default PDFReader;
